import * as React from 'react';
export default React.createContext({
    scrollRef: null,
    addRefToVisibilbityMap: () => {
        return;
    },
    removeRefFromVisibilbityMap: () => {
        return;
    },
});
//# sourceMappingURL=ScrollableContext.js.map